const pad = (value) => String(value).padStart(2, '0');

export const parseFlexibleDate = (value, options = {}) => {
  const { preferMonthFirst = false } = options;
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number') {
    // Excel serials represent calendar days, not UTC instants. Rebuild the
    // date from UTC components so western time zones do not subtract one day.
    const excelDate = new Date((Math.floor(value) - 25569) * 86400 * 1000);
    if (Number.isNaN(excelDate.getTime())) return null;
    return new Date(
      excelDate.getUTCFullYear(),
      excelDate.getUTCMonth(),
      excelDate.getUTCDate()
    );
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const datePart = raw.includes('T') ? raw.split('T')[0] : raw;
  const normalized = datePart.replace(/\./g, '-').replace(/\//g, '-');
  const parts = normalized.split('-').filter(Boolean);

  if (parts.length === 3) {
    if (parts[0].length === 4) {
      const year = Number(parts[0]);
      const month = Number(parts[1]) - 1;
      const day = Number(parts[2]);
      const parsed = new Date(year, month, day);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    if (parts[2].length === 4) {
      const first = Number(parts[0]);
      const second = Number(parts[1]);
      let day = first;
      let month = second - 1;

      if (first > 12 && second <= 12) {
        day = first;
        month = second - 1;
      } else if (second > 12 && first <= 12) {
        day = second;
        month = first - 1;
      } else if (preferMonthFirst) {
        day = second;
        month = first - 1;
      }

      const year = Number(parts[2]);
      const parsed = new Date(year, month, day);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const normalizeDateForStorage = (value, options = {}) => {
  const parsed = parseFlexibleDate(value, options);
  if (!parsed) return '';

  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
};

export const formatDateDisplay = (value, options = {}) => {
  const parsed = parseFlexibleDate(value, options);
  if (!parsed) return '';

  return `${pad(parsed.getDate())}/${pad(parsed.getMonth() + 1)}/${parsed.getFullYear()}`;
};

export const dateToTimestamp = (value, options = {}) => {
  const parsed = parseFlexibleDate(value, options);
  return parsed ? parsed.getTime() : 0;
};

export const todayAsStorageDate = () => normalizeDateForStorage(new Date());
